export default __webpack_public_path__ + "25fe3e43979df367b4bbeea3e478dab3.ply";